import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { FileUploadCell } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { RFQContainer } from 'routes/ProcurementSystem/RequestForQuotation/styled'

const PRBudget = props => {
  const { isCreate = false, isEdit = false, sapDetail, valueForm = {}, change } = props

  return (
    <RFQContainer>
      <div className='rowFields'>
        <Field
          name='prBudget'
          label='PR Budget'
          editable={false}
          suffix={` ${sapDetail.currencyCode}`}
          type={type.number}
          fixedDecimalScale
          component={FieldInput}
        />
        <Field
          name='costSaving'
          label='Cost Saving'
          type={type.number}
          editable={false}
          fixedDecimalScale
          suffix={` ${sapDetail.currencyCode}`}
          component={FieldInput}
        />
      </div>
      <div className='rowFields'>
        <Field
          name='amountAfterDiscount'
          label='RFQ After Discount Amount'
          editable={false}
          type={type.number}
          suffix={` ${sapDetail.currencyCode}`}
          fixedDecimalScale
          component={FieldInput}
        />
        <Field
          name='costSavingPercent'
          label='Cost Saving (%)'
          suffix='%'
          editable={false}
          type={type.number}
          fixedDecimalScale
          component={FieldInput}
        />
      </div>
      <div className='rowFields'>
        <Field
          name='remark'
          label='Remark'
          type={type.textArea}
          component={FieldInput}
          editable={(isCreate || isEdit)}
        />
      </div>
      {
        (!(isCreate || isEdit) && (valueForm.bargained === null || valueForm.bargained === undefined)) ? null :
        <div className='rowFields'>
          <Field
            name='bargained'
            label='การต่อรองราคา'
            require
            type={type.radio}
            options={[
              { text: 'ผ่านการต่อรองราคาแล้ว', value: true },
              { text: 'ไม่ผ่านการต่อรองราคา', value: false }
            ]}
            component={FieldInput}
            editable={(isCreate || isEdit)}
          />
        </div>
      }
      {
        valueForm.bargained !== null && valueForm.bargained !== undefined ?
          <React.Fragment>
            <div className='rowFields'>
              <Field
                require
                name='bargainRemark'
                label={valueForm.bargained ? 'ผลการต่อรองราคา' : 'เหตุผล'}
                type={type.textArea}
                component={FieldInput}
                editable={(isCreate || isEdit)}
              />
            </div>
            {
              (isCreate || isEdit) ?
                <div className='rowFields'>
                  <Field
                    require={valueForm.bargained}
                    name='rfq04'
                    label='เอกสารการต่อรองราคา'
                    type={type.file}
                    component={FieldInput}
                    editable={(isCreate || isEdit)}
                    showOldFile={isEdit}
                    oldFiles={(valueForm.rfqAttachments || []).filter(x => x.documentTypeCode.toLowerCase() === 'rfq04' && !x.deleted) || []}
                    removeOldFiles={(i, code) => {
                      let oldFiles = (valueForm.rfqAttachments || []).filter(x => x.documentTypeCode.toLowerCase() === 'rfq04' && !x.deleted) || []
                      let index = valueForm.rfqAttachments.findIndex(x => x.filename === oldFiles[i].filename)
                      change(`rfqAttachments[${index}].deleted`, true)
                    }}
                  />
                </div> : null
            }
          </React.Fragment>
          : null
      }
    </RFQContainer>
  )
}
const mapStateToProps = (state, props) => {
  return {
    sapDetail: state.rfq.sapDetails.data ? state.rfq.sapDetails.data : {},
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PRBudget)
